import { useEffect, useState } from 'react'

import { useDebouncedCallback } from '@/legacy-src/hooks/useDebouncedCallback'

export const useDebouncedState = <T>({
  value: defaultValue,
  callback,
  wait = 250,
}: {
  value: T
  callback: (value: T) => void
  wait?: number
}) => {
  const [value, setValue] = useState(defaultValue)

  useEffect(() => {
    setValue(defaultValue)
  }, [defaultValue])

  const handler = useDebouncedCallback(callback, wait)

  const onChange = (newValue: T) => {
    setValue(newValue)
    handler(newValue)
  }

  return {
    value,
    onChange,
  }
}
